 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLE_PAGE from '@/components/title_page'
 import DEDICATION from '@/components/Dedication'
 import NAV from '@/components/nav'
 import INTRODUCTION from '@/components/Introduction'
 import FOREWORD from '@/components/Foreword'
 import PROLOGUE from '@/components/Prologue'
 import PART_I from '@/components/Part_I'
 import CHAPTER1_MOTHER_DEAR_MA from '@/components/Chapter1_Mother_Dear_Ma'
 import CHAPTER_2_AS_I_YEARN_SO from '@/components/Chapter_2_As_I_Yearn_So'
 import CHAPTER_3_ILL_NEVER_LOS from '@/components/Chapter_3_Ill_Never_Los'
 import CHAPTER_4_THE_CHESS_LESS from '@/components/Chapter_4_The_Chess_Less'
 import CHAPTER_5_THE_RAMSEY_LEW from '@/components/Chapter_5_The_Ramsey_Lew'
 import CHAPTER_6_THE_WORLD_CAN from '@/components/Chapter_6_The_World_Can'
 import PART_II from '@/components/Part_II'
 import CHAPTER_7_STARTING_FROM_ from '@/components/Chapter_7_Starting_from_'
 import CHAPTER_8_HEARTS_OF_FIRE from '@/components/Chapter_8_Hearts_of_Fire'
 import CHAPTER_9_TRUSTING_IN_TH from '@/components/Chapter_9_Trusting_in_th'
 import CHAPTER_10_STEP from '@/components/Chapter_10_Step'
 import PART_III from '@/components/Part_III'
 import CHAPTER_11_TRUE_PRIDE from '@/components/Chapter_11_True_Pride'
 import CHAPTER_12_ACCEPTING_LIF from '@/components/Chapter_12_Accepting_Lif'
 import CHAPTER_13_THATS_THE_WA from '@/components/Chapter_13_Thats_the_Wa'
 import CHAPTER_14_EXPANSION from '@/components/Chapter_14_Expansion'
 import CHAPTER_15_GRATITUDE from '@/components/Chapter_15_Gratitude'
 import CHAPTER_16_DEPARTURE from '@/components/Chapter_16_Departure'
 import PART_IV from '@/components/Part_IV'
 import CHAPTER_17_MUSICAL_AND_S from '@/components/Chapter_17_Musical_and_S'
 import CHAPTER_18_THE_BEST_OF_M from '@/components/Chapter_18_The_Best_of_M'
 import CHAPTER_19_ALL_N_ALL from '@/components/Chapter_19_All_N_All'
 import CHAPTER_20_MUSICAL_THEAT from '@/components/Chapter_20_Musical_Theat'
 import CHAPTER_21_BEGINNINGS_AN from '@/components/Chapter_21_Beginnings_an'
 import CHAPTER_22_A_HELL_OF_A_L from '@/components/Chapter_22_A_Hell_of_a_L'
 import CHAPTER_23_I_AM from '@/components/Chapter_23_I_Am'
 import PART_V from '@/components/Part_V'
 import CHAPTER_24_ALL_IN_THE_CR from '@/components/Chapter_24_All_in_the_Cr'
 import CHAPTER_25_DONT_MAKE_MY from '@/components/Chapter_25_Dont_Make_My'
 import CHAPTER_26_THE_GROOVE from '@/components/Chapter_26_The_Groove'
 import CHAPTER_27_BLACK_TAX from '@/components/Chapter_27_Black_Tax'
 import CHAPTER_28_SOMETHINGS_G from '@/components/Chapter_28_Somethings_G'
 import CHAPTER_29_ON_THE_SOLO from '@/components/Chapter_29_On_the_Solo'
 import CHAPTER_30_BLINDSIDED from '@/components/Chapter_30_Blindsided'
 import CHAPTER_31_NOT_FITTING_I from '@/components/Chapter_31_Not_Fitting_I'
 import CHAPTER_32_A_TIME_OF_SYM from '@/components/Chapter_32_A_Time_of_Sym'
 import CHAPTER_33_LETTING_GO from '@/components/Chapter_33_Letting_Go'
 import PART_VI from '@/components/Part_VI'
 import CHAPTER_34_TIME_WILL_WIT from '@/components/Chapter_34_Time_Will_Wit'
 import CHAPTER_35_WHEN_MY_FINAL from '@/components/Chapter_35_When_My_Final'
 import LOVE_2 from '@/components/love_2'
 import AFTERWORD from '@/components/Afterword'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import PERMISSIONS from '@/components/Permissions'
 import INDEX from '@/components/Index'
 import PHOTO_INSERT from '@/components/Photo_Insert'
 import ABOUT_THE_AUTHOR from '@/components/About_the_Author'
 import BOOK_PERK_AD from '@/components/Book_Perk_Ad'
 import COPYRIGHT_EBOOK from '@/components/Copyright_ebook'
 import ABOUT_THE_PUBLISHER from '@/components/About_the_Publisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/Dedication",
 			"name" : "Dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/nav",
 			"name" : "nav",
 			"component" : NAV
 		},
 		{
 			"path" : "/Introduction",
 			"name" : "Introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/Foreword",
 			"name" : "Foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/Prologue",
 			"name" : "Prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/Part_I",
 			"name" : "Part_I",
 			"component" : PART_I
 		},
 		{
 			"path" : "/Chapter1_Mother_Dear_Ma",
 			"name" : "Chapter1_Mother_Dear_Ma",
 			"component" : CHAPTER1_MOTHER_DEAR_MA
 		},
 		{
 			"path" : "/Chapter_2_As_I_Yearn_So",
 			"name" : "Chapter_2_As_I_Yearn_So",
 			"component" : CHAPTER_2_AS_I_YEARN_SO
 		},
 		{
 			"path" : "/Chapter_3_Ill_Never_Los",
 			"name" : "Chapter_3_Ill_Never_Los",
 			"component" : CHAPTER_3_ILL_NEVER_LOS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js